import { Link } from "react-router-dom";
import { Users, UserCheck, CreditCard, ClipboardList, CalendarClock, MessageSquare, FolderOpen, Building2 } from "lucide-react";
import { PageHeader } from "@/components/Common";
import { useFetch } from "@/lib/api";

const CARDS = [
  ["candidates", "Candidates", Users, "/admin/candidates"],
  ["available", "Available now", UserCheck, "/admin/candidates"],
  ["members", "Business accounts", Building2, "/admin/members"],
  ["active_members", "Active members", CreditCard, "/admin/members"],
  ["pending_hires", "Pending hires", ClipboardList, "/admin/requests"],
  ["pending_interviews", "Interview requests", CalendarClock, "/admin/requests"],
  ["unread_messages", "Unread messages", MessageSquare, "/admin/messages"],
  ["resources", "Business files", FolderOpen, "/admin/resources"],
];

export default function AdminOverview() {
  const { data } = useFetch("/admin/stats");
  return (
    <div>
      <PageHeader eyebrow="Admin console" title="Workforce operations" desc="Manage candidates, respond to clients and keep the pipeline moving." />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {CARDS.map(([k, label, Icon, to]) => (
          <Link key={k} to={to} data-testid={`admin-stat-${k}`} className="lift rounded-md border border-stone-200 bg-white p-6">
            <Icon className="h-5 w-5 text-stone-500" strokeWidth={1.5} />
            <p className="mt-6 font-display text-4xl font-extrabold text-stone-900">{data?.[k] ?? "–"}</p>
            <p className="mt-1 text-xs font-mono uppercase tracking-wider text-stone-500">{label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
